export const productSchema = [
  {
    id: 0,
    name: "category",
    status: "",
    message: "",
    question: "Select Category Of Your Product",
    success: false,
    errorMsg: "Select one of the category",
    isError: false,
    explanation: "",
  },
  {
    id: 1,
    name: "subCategory",
    status: "",
    message: "",
    question: "Select Sub Category Of Your Product",
    success: false,
    errorMsg: "Select one of the sub category",
    isError: false,
    explanation: "",
  },
  {
    id: 2,
    name: "title",
    status: "",
    message: "Your Product's name",
    question: "Product Title",
    success: false,
    errorMsg: "The name is not valid",
    isError: false,
    explanation: "",
  },
  {
    id: 3,
    name: "definition",
    status: "",
    message: "A short brief",
    question: "What is this product?",
    success: false,
    errorMsg: "Please make a definition",
    isError: false,
    explanation: "",
  },
  {
    id: 4,
    name: "productImageUrl",
    status: "",
    message: "Paste the image's URL",
    question: "Image Url",
    success: false,
    errorMsg: "Try again please",
    isError: false,
    explanation: "",
  },
  {
    id: 5,
    name: "stockCount",
    status: "",
    message: "How many product do you have?",
    question: "Stock Count",
    success: false,
    errorMsg: "Enter a number please",
    isError: false,
    explanation: "",
  },
  {
    id: 6,
    name: "specifications",
    status: [
      {
        nameSpec: "",
        specification: "",
        success: false,
        msg: "enter values please",
      },
    ],
    message: "e.g. battery life",
    question: "What is your product's specifications ?",
    success: false,
    errorMsg: "Enter valid please",
    isError: false,
    explanation: "5 hours",
  },
  {
    id: 7,
    name: "price",
    status: { number: "", decimal: "" },
    message: "Enter The Price",
    question: "Price",
    success: false,
    errorMsg: "Please enter number",
    isError: false,
    explanation: "Decimal Point",
  },

  {
    id: 8,
    name: "discountPercent",
    status: "",
    message: "How much discount you will make",
    question: "Discount Percent",
    success: false,
    errorMsg: "Select one",
    isError: false,
    explanation: "",
  },
  {
    id: 9,
    name: "warranty",
    status: "",
    message: "",
    question: "Does this product have warranty?",
    success: false,
    errorMsg: "",
    isError: false,
    explanation: "",
  },
  {
    id: 10,
    name: "warrantyExplanation",
    status: "",
    message: "How many months does this product have warranty?",
    question: "Warranty period",
    success: false,
    errorMsg: "Enter a valid number",
    isError: false,
    explanation: "",
  },
];
